import SimpleBillingModalComponent from './SimpleBillingModalComponent'

export default SimpleBillingModalComponent
